$(function() {
  const searchForm = $('.form-anunciante-search')
  if (searchForm.length) {
    $('.form-anunciante-search').on('submit', event => {
      event.preventDefault()

      let url = $(searchForm).attr('action')
      const cidade = $(searchForm)
        .find('#busca-cidade')
        .val()

      if (cidade) url = url + '/' + cidade

      const params = []

      const creci = $(searchForm)
        .find('input[name=creci]')
        .val()
      if (creci) params.push('creci=' + creci)

      const nome = $(searchForm)
        .find('input[name=nome]')
        .val()
      if (nome) params.push('nome=' + encodeURIComponent(nome))

      if (params.length > 0) url = url + '?' + params.join('&')

      window.location.href = url

      return false
    })
  }
})
